import React from "react";
import { Link } from "react-router-dom";

import {
  Context,
  textbookPath,
  chooseTextbookPath,
} from "../../../teacherStore";
import { LABELS } from "../../../constants/teaching_materials";
import Button from "../../../atoms/ActiveLearning/Button";

import styles from "./SelectTextbookPage.module.scss";

export default () => {
  const { state } = React.useContext(Context);

  return (
    <div className={styles.wrapper} id="accordion">
      <div className={styles.container}>
        <p className={styles.title}>授業する教材を選んでください</p>
        <div className={styles.buttonWrapper}>
          <Link
            className={styles.link}
            to={`${textbookPath}${chooseTextbookPath}`}
          >
            <Button width={"100%"}>
              {state.has_base && `${LABELS.base}/`}
              {LABELS.coreBasic}
            </Button>
          </Link>
          <Link
            className={styles.link}
            to={`${textbookPath}${chooseTextbookPath}?isActiveLearning=true`}
          >
            <Button width={"100%"}>{LABELS.coreActiveLearning}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
